import gsap from "gsap";

// get other plugins:
import ScrollTrigger from "gsap/ScrollTrigger";
import Observer from "gsap/Observer";

// don't forget to register plugins
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Observer);

const settings = window.scrollSettings;

if(settings.template === 'template-1') {

    /* particlesJS.load(@dom-id, @path-json, @callback (optional)); */
    let jsonFile = window.location.href.includes('test') ? '/app' : '/wp-content';
    jsonFile += '/plugins/site-widgets/src/HeroScroll/js/particlesjs-config.json';
    particlesJS.load('particles-js', jsonFile, function () {
        // console.log('callback - particles.js config loaded');
    });


    gsap.to('.rotating-img img', {
        opacity: 1,
        duration: 1,
        ease: 'power1.in',
    });


// ----------------------------------------------//
// Observer solution
// ----------------------------------------------//

    let outerContainer = document.querySelector(".elementor-widget-webien_hero_scroll .container"),
        animating, observer;

    const tl = gsap.timeline({paused: true});


    let observerSettings = {
        //target: window, // can be any element (selector text is fine)
        type: "wheel,touch, pointer", // comma-delimited list of what to listen for
        wheelSpeed: -1,
        onUp: () => !animating && gotoSection('down'),
        onDown: () => !animating && gotoSection('up'),
        tolerance: 10,
        preventDefault: true
    };


    if (settings.autoplay) {
        setTimeout(() => {
            tl.play();
        }, settings.delay * 1000);
    } else {
        if (window.scrollY === 0) {
            observer = Observer.create(observerSettings);
        }
    }

    if (window.scrollY === 0) {
        document.documentElement.classList.add('scroll-block');
        gsap.set('.section-2', {yPercent: 100, scale: 0.2, opacity: 0});
    }


    tl.to('.rotating-img', {
        rotation: 360,
        duration: 2,
        delay: 0,
        scale: 5,
        opacity: 0,
        ease: 'power1.in',
    }, 0)
        .to('.section-1', {
            duration: 1,
            delay: 0,
            y: -300
        }, 1)
        .to('.section-1', {
            duration: 0.3,
            delay: 0,
            opacity: 0,
        }, 1)
        .to('.section-2', {
            duration: 0,
            delay: 0,
            yPercent: 0,
        }, 1)
        .to('.section-2', {
            duration: 0.6,
            delay: 0.6,
            opacity: 1,
            scale: 1,
            ease: 'power4.out',
        }, 1)

        .to('#particles-js', {
            duration: 3,
            y: -400,
            'onComplete': () => {
                animating = false;
                disableScrollAnimation();
            }
        }, 0);

    function gotoSection(direction) {

        //console.log('direction', direction);

        if (animating) return;
        animating = true;

        if (direction === 'down') {
            tl.play();
        }

        if (direction === 'up') {
            tl.reverse().then(() => {
                animating = false;
                outerContainer.classList.remove('scroll-disabled');
                observer.enable();
            });

        }

    }

    function disableScrollAnimation() {
        if (!settings.autoplay) {
            observer.disable();
        }

        outerContainer.classList.add('scroll-disabled');
        // Add class to html tag
        document.documentElement.classList.remove('scroll-block');
    }

}

// ----------------------------------------------//
// End Observer solution
// ----------------------------------------------//

